import React, { useEffect, useState, useMemo } from 'react';
import Slide from '@material-ui/core/Slide';
import {
  Box,
  Card,
  Popover,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  Divider,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';

import ToolBarTracking from 'src/app/components/ToolBarTracking';
import CarStatusBar from './CarStatusBar';
import { CAR_STATUS } from 'src/app/constant/config';
import { resetListVehicle } from 'src/features/vehicleSlice';
import {
  ButtonHideMenuTracking,
  ButtonShowMenuTracking
} from '../button/ButtonMenu';
import { useQuery } from 'src/app/hooks/useQuery';
import VehicleTreeTracking from 'src/app/components/tables/VehicleTableTracking';
import VehicleTableMini from 'src/app/components/tables/VehicleTableMini';

const HEADER_HEIGHT = 66;
const useMobileStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1300,
    background: '#fff',
    borderRadius: '12px 12px 0 0',
    boxShadow: '0 -4px 16px rgba(0,0,0,.15)',
    transition: 'height .25s ease'
  },
  collapsed: { height: 150 },
  expanded: { height: `calc(100dvh - ${HEADER_HEIGHT}px)` },
  handle: {
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    touchAction: 'none'
  },
  handleBar: { width: 40, height: 4, borderRadius: 2, background: '#ccc' },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 12px 36px'
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: '4px'
  },
  listWrapper: { flex: 1, overflowY: 'auto', marginTop: '8px' }
}));

const MobileMenu = ({
  getVehicle,
  idSelected,
  listVehicleTable,
  currentCount,
  onNodeClick,
  search_agency_id,
  carStatus,
  setCarStatus,
  baseDeviceCount,
  onRefresh,
  extraCount = 0
}) => {
  const classes = useMobileStyles();
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { isAdmin, isAgency } = useSelector(state => state.authSlice);
  const title = (isAdmin || isAgency) ? 'Danh sách đại lý/người dùng' : 'Danh sách thiết bị';

  const handleReset = () => {
    setCarStatus('');
    dispatch(resetListVehicle());
    if (onRefresh) onRefresh();
  };
  return (
    <>
      <Box
        className={`${classes.root} ${expanded ? classes.expanded : classes.collapsed
          }`}
      >
        <div className={classes.handle} onClick={() => setExpanded(v => !v)}>
          <div className={classes.handleBar} />
        </div>

        <Box className={classes.content}>
          <Box
            className={classes.headerRow}
            onClick={() => !expanded && setExpanded(true)}
          >
            <Typography style={{ fontWeight: 600, fontSize: 14 }}>
              {title} ({currentCount + extraCount}/{listVehicleTable.length + extraCount})
            </Typography>
            <Box display="flex" alignItems="center">
              <span
                onClick={e => {
                  e.stopPropagation();
                  handleReset();
                }}
                className="list_tracking_action"
              >
                <img alt="sync" src="/static/iconSvg/sync.svg" />
              </span>
              <span
                onClick={e => {
                  e.stopPropagation();
                  setAnchorEl(e.currentTarget);
                }}
                className="list_tracking_action"
              >
                <img alt="info" src="/static/iconSvg/notice.svg" />
              </span>
            </Box>
          </Box>

          {!expanded && (
            <Box mt={1}>
              <CarStatusBar
                carStatus={carStatus}
                setCarStatus={setCarStatus}
              />
            </Box>
          )}

          {expanded && (
            <>
              <ToolBarTracking />
              <Box className={classes.listWrapper}>
                <VehicleTreeTracking
                  vehicles={listVehicleTable}
                  getVehicle={getVehicle}
                  carStatus={carStatus}
                  onNodeClick={onNodeClick}
                  rowActive={idSelected}
                  search_agency_id={search_agency_id}
                />
              </Box>
              <CarStatusBar
                carStatus={carStatus}
                setCarStatus={setCarStatus}
              />
            </>
          )}
        </Box>
      </Box>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box p={2} width={300}>
          <Typography align="center" gutterBottom>
            <b>Chú thích</b>
          </Typography>
          <List>
            {CAR_STATUS.map((car, i) => (
              <React.Fragment key={i}>
                <ListItem>
                  <ListItemAvatar>
                    <img
                      alt=""
                      src={`/static/iconSvg/carsv2/${car.icon}.svg`}
                    />
                  </ListItemAvatar>
                  <Typography variant="body2">{car.info}</Typography>
                </ListItem>
                {i < CAR_STATUS.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Popover>
    </>
  );
};

const useDesktopStyles = makeStyles(theme => ({
  typography: { padding: theme.spacing(2), width: '375px' },
  listInformation: {
    width: '100%',
    maxWidth: 375,
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper
  },
  popoverHeader: { textAlign: 'center' },
  textInforCar: {
    color: '#0C1132 !important',
    fontSize: '14px !important',
    lineHeight: '19.6px',
    fontWeight: 400,
    padding: '15px 0'
  },
  syncIcon: {
    transition: 'transform 0.3s ease',
    '&.clicked': {
      animation: '$pulse 0.5s ease-in-out'
    },
    '& img': {
      transition: 'filter 0.3s ease'
    },
    '&.clicked img': {
      animation: '$flashRed 0.5s ease-in-out'
    }
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)'
    },
    '50%': {
      transform: 'scale(1.2)'
    },
    '100%': {
      transform: 'scale(1)'
    }
  },
  '@keyframes flashRed': {
    '0%, 100%': {
      filter: 'none'
    },
    '50%': {
      filter:
        'brightness(0) saturate(100%) invert(17%) sepia(96%) saturate(4439%) hue-rotate(352deg) brightness(96%) contrast(103%)'
    }
  },
  resizeHandle: {
    height: '10px',
    backgroundColor: '#f5f5f5',
    cursor: 'ns-resize',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderTop: '1px solid rgba(0,0,0,0.1)',
    borderBottom: '1px solid rgba(0,0,0,0.1)',
    '&:hover': {
      backgroundColor: '#eeeeee'
    }
  },
  handleBar: {
    width: '40px',
    height: '4px',
    borderRadius: '2px',
    backgroundColor: '#bdbdbd'
  }
}));

const DesktopMenu = ({
  getVehicle,
  idSelected,
  carStatus,
  setCarStatus,
  showMenu,
  setShowMenu,
  totalCount,
  onNodeClick,
  search_agency_id,
  baseDeviceCount,
  onRefresh,
  extraCount = 0
}) => {
  const classes = useDesktopStyles();
  const dispatch = useDispatch();
  const listVehicleTracking = useSelector(
    state => state.vehicleSlice.listVehicleTracking
  );
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isIconClicked, setIsIconClicked] = React.useState(false);

  const query = useQuery();
  const license_plate = query.get('license_plate');
  const [listVehicleTable, setListVehicleTable] = React.useState(
    listVehicleTracking || []
  );

  const { isUser, isAdmin, isAgency, isDriver } = useSelector(
    state => state.authSlice
  );
  const isUserLike = isUser || isDriver;

  useEffect(() => {
    setListVehicleTable(listVehicleTracking);
  }, [listVehicleTracking]);

  useEffect(() => {
    if (carStatus) {
      const listVehicleStatus = listVehicleTracking.filter(
        vehicle => vehicle.device_status === carStatus && vehicle.debt === false
      );
      setListVehicleTable(listVehicleStatus);
    } else {

      let filtered = [...listVehicleTracking];
      if (isUserLike && license_plate) {
        filtered = filtered.filter(v => {
          const vData = v.vehicle || v;
          const lp = vData.license_plate || v.license_plate || '';
          return lp.toUpperCase().includes(license_plate.toUpperCase());
        });
      }

      setListVehicleTable(filtered);
    }
  }, [carStatus, listVehicleTracking, isUserLike, license_plate]);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseInfo = () => {
    setAnchorEl(null);
  };

  const handleReset = () => {
    setCarStatus('');
    dispatch(resetListVehicle());
    if (onRefresh) onRefresh();
    setIsIconClicked(true);
    setTimeout(() => {
      setIsIconClicked(false);
    }, 500);
  };

  const [bottomHeight, setBottomHeight] = React.useState(350);
  const [isResizing, setIsResizing] = React.useState(false);

  const startResizing = React.useCallback((e) => {
    setIsResizing(true);
    e.preventDefault();
  }, []);

  React.useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isResizing) return;
      const cardRect = document.getElementById('menu-card')?.getBoundingClientRect();
      if (!cardRect) return;

      const newHeight = cardRect.bottom - e.clientY;
      if (newHeight > 100 && newHeight < cardRect.height - 150) {
        setBottomHeight(newHeight);
      }
    };

    const handleMouseUp = () => {
      setIsResizing(false);
    };

    if (isResizing) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing]);

  const open = Boolean(anchorEl);
  const iconInfo = open ? 'notice' : 'notice_gray';
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <Slide
        direction="right"
        in={showMenu}
        style={{
          height: '100%',
          borderRadius: '8px',
          zIndex: 450,
          boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
          borderTop: '1px solid rgba(0,0,0,0.08)'
        }}
      >
        <Card
          id="menu-card"
          style={{
            paddingTop: '50px',
            padding: '1em',
            width: '384px',
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}
        >
          <ToolBarTracking/>

          <Box
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: '14px',
              marginBottom: '0px'
            }}
          >
            <Typography
              style={{ color: '#0C1132', fontSize: '16px', fontWeight: 600 }}
            >
              {isAdmin || isAgency ? `Danh sách đại lý/người dùng: ${totalCount}` : `Danh sách thiết bị: ${totalCount}`}
            </Typography>
            <Box
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <span
                  className={`${classes.syncIcon} list_tracking_action ${isIconClicked ? 'clicked' : ''
                    }`}
                  onClick={handleReset}
                >
                  <img alt="icon" src={`/static/iconSvg/sync.svg`} />{' '}
                </span>
                <span
                  className="list_tracking_action"
                  aria-describedby={id}
                  onClick={handleClick}
                >
                  <img alt="icon" src={`/static/iconSvg/${iconInfo}.svg`} />
                </span>
              </Box>

              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                  }}
                >
                  <Typography className={classes.typography}>
                    <div className={classes.popoverHeader}>
                      <b> Chú thích </b>
                      <span className="float-right">
                        <img
                          alt="button_close"
                          className="list_tracking_action"
                          onClick={handleClose}
                          width="12px"
                          height="12px"
                          src="/static/iconSvg/close-btn.svg"
                        />
                      </span>
                    </div>

                    <List className={classes.listInformation}>
                      {CAR_STATUS &&
                        CAR_STATUS.map((car, index) => (
                          <>
                            <ListItem>
                              <ListItemAvatar>
                                <img
                                  alt="icon"
                                  src={`/static/iconSvg/carsv2/${car?.icon}.svg`}
                                  className="imageCarInfo"
                                />
                              </ListItemAvatar>
                              <span className={classes.textInforCar}>
                                {car?.info}
                              </span>
                            </ListItem>
                            {CAR_STATUS.length !== index + 1 ? (
                              <Divider variant="inset" component="li" />
                            ) : null}
                          </>
                        ))}
                    </List>
                  </Typography>
                </Popover>
              </Box>
            </Box>
          </Box>

          {!isUserLike && (
            <>
              <Box style={{ flex: 1, overflowY: 'hidden', marginTop: '10px' }}>
                <VehicleTreeTracking
                  vehicles={listVehicleTable}
                  getVehicle={getVehicle}
                  carStatus={carStatus}
                  onNodeClick={onNodeClick}
                  rowActive={idSelected}
                  search_agency_id={search_agency_id}
                  showVehiclesInTree={false}
                />
              </Box>

              <div
                className={classes.resizeHandle}
                onMouseDown={startResizing}
              >
                <div className={classes.handleBar} />
              </div>
            </>
          )}

          <Box style={{
            height: isUserLike ? 'auto' : bottomHeight,
            flex: isUserLike ? 1 : 'none',
            marginTop: isUserLike ? '10px' : '0px',
            minHeight: 100,
            overflow: 'hidden',
            backgroundColor: '#fff',
            borderTop: isUserLike ? 'none' : '1px solid #ddd'
          }}>
            <VehicleTableMini
              vehicles={listVehicleTable}
              getVehicle={getVehicle}
              idSelected={idSelected}
              showSearch={!isUserLike}
              total={totalCount}
              extraCount={extraCount}
              baseDeviceCount={baseDeviceCount}
            />
          </Box>

          <ButtonShowMenuTracking
            showMenu={showMenu}
            setShowMenu={setShowMenu}
          />
        </Card>
      </Slide>

      <ButtonHideMenuTracking showMenu={showMenu} setShowMenu={setShowMenu} />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseInfo}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Typography className={classes.typography}>
          <div className={classes.popoverHeader}>
            <b>Chú thích</b>
            <span className="float-right">
              <img
                alt="close"
                className="list_tracking_action"
                onClick={handleCloseInfo}
                width="12px"
                height="12px"
                src="/static/iconSvg/close-btn.svg"
              />
            </span>
          </div>

          <List className={classes.listInformation}>
            {CAR_STATUS.map((car, index) => (
              <React.Fragment key={index}>
                <ListItem>
                  <ListItemAvatar>
                    <img
                      alt="icon"
                      src={`/static/iconSvg/carsv2/${car?.icon}.svg`}
                      className="imageCarInfo"
                    />
                  </ListItemAvatar>
                  <span className={classes.textInforCar}>{car?.info}</span>
                </ListItem>
                {CAR_STATUS.length !== index + 1 && (
                  <Divider variant="inset" component="li" />
                )}
              </React.Fragment>
            ))}
          </List>
        </Typography>
      </Popover>
    </>
  );
};

const MenuBoxTracking = ({
  getVehicle,
  idSelected,
  setShowMenu,
  showMenu,
  setCarStatus,
  carStatus,
  onNodeClick,
  search_agency_id,
  totalDeviceCount,
  baseDeviceCount,
  onRefresh,
  extraCount = 0
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const listVehicleTracking = useSelector(
    state => state.vehicleSlice.listVehicleTracking
  );

  const [listVehicleTable, setListVehicleTable] = useState([]);
  const [currentCount, setCurrentCount] = useState(0);

  useEffect(() => {
    const filtered = carStatus
      ? listVehicleTracking.filter(v => v.device_status === carStatus)
      : listVehicleTracking;

    setListVehicleTable(filtered);
    setCurrentCount(filtered.length);
  }, [listVehicleTracking, carStatus]);

  const commonProps = React.useMemo(() => ({
    getVehicle,
    idSelected,
    listVehicleTable,
    currentCount,
    onNodeClick,
    search_agency_id,
    totalCount: totalDeviceCount ?? (listVehicleTracking?.length || 0),
    carStatus,
    setCarStatus,
    extraCount,
    baseDeviceCount,
    onRefresh
  }), [
    getVehicle,
    idSelected,
    carStatus,
    setCarStatus,
    listVehicleTable,
    currentCount,
    onNodeClick,
    search_agency_id,
    listVehicleTracking,
    totalDeviceCount,
    extraCount,
    baseDeviceCount,
    onRefresh
  ]);

  return isMobile ? (
    <MobileMenu {...commonProps} />
  ) : (
    <DesktopMenu
      {...commonProps}
      showMenu={showMenu}
      setShowMenu={setShowMenu}
    />
  );
};

export default React.memo(MenuBoxTracking);
